import styled from '../../styled';
import { COLORS } from '../../themes/color';

/**
 * Light product chrome shared by the Amplify page mockups. The body
 * background mirrors the app's warm gray canvas so the white cards
 * inside read like the real product.
 */
export const ProductMockupFrame = styled('div')`
  width: 100%;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(14, 28, 43, 0.08);
`;

export const ProductMockupHeader = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid #f1f5f9;
  background: #fff;
`;

export const ProductMockupLabel = styled('span')`
  font-family: 'SF Mono', 'Roboto Mono', 'Fira Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${COLORS.PRIMARY};
`;

export const ProductMockupBody = styled('div')`
  padding: 16px 18px 18px;
  background: #f6f6f4;
`;

export const MockupDots = styled('div')`
  display: flex;
  gap: 5px;

  span {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: #e2e8f0;
  }
`;

/** Small colored initial circle standing in for a merchant logo. */
export const MerchantDot = styled('span')<{ bg: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: ${(p) => p.bg};
  color: #fff;
  font-size: 8px;
  font-weight: 700;
  flex-shrink: 0;
`;
